import React from 'react';
import MainPage from './MainPage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivacyPolicy from './PrivacyPolicy';
import { ReturnPolicy, TermsOfService } from './ReturnTermsPolicy';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/return-policy" element={<ReturnPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        { /* User panel removed – handled by ExtensionPay */ }
      </Routes>
    </Router>
  );
}

export default App;
